import React from 'react'
import classNames from 'classnames'

import styles from './FeaturedItem.module.scss'
import { ReactComponent as ArrowSVG } from './ArrowSVG.svg'
import { navAttrs } from '../../../helpers/navClickTracking'

interface FeaturedItemProps {
  isDarkMode?: boolean
  navSection?: string
  data?: {
    title?: string
    linkLabel?: string
    url?: string
    image?: string
  }
}

const DEFAULT_DATA = {
  title: 'Understanding Smart Signals',
  linkLabel: 'Read More',
  url: '/blog/power-of-smart-signals-fraud-detection-prevention/',
  image: undefined,
}

function FeaturedItem({ isDarkMode, data, navSection }: FeaturedItemProps) {
  const title = data?.title ?? DEFAULT_DATA.title
  const linkLabel = data?.linkLabel ?? DEFAULT_DATA.linkLabel
  const url = data?.url ?? DEFAULT_DATA.url
  const image = data?.image ?? DEFAULT_DATA.image

  return (
    <a
      href={url}
      rel='noreferrer'
      style={{ height: '100%' }}
      target='_blank'
      {...(navSection ? navAttrs('top', navSection, 'Featured') : {})}
    >
      <div className={classNames(styles.container, { [styles.darkContainer]: isDarkMode })}>
        <h5>Featured</h5>
        {image ? <img src={image} alt={title} className={styles.image} /> : null}
        <div className={styles.info}>
          <h4>{title}</h4>
          <p className={styles.link}>
            {linkLabel} <ArrowSVG className={styles.arrow} />
          </p>
        </div>
      </div>
    </a>
  )
}

export default FeaturedItem
